module.exports = __webpack_public_path__ + "static/img/QYZ.ccb9a82e.jpg";